var WaitListAppointmentsModel = require('../wait-list-appointments/appointment');

var WaitListsAppointmentsModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    isInitialized: false,
    hasAppointments: false,
    waitLists: new Backbone.Collection(null, { model: WaitListAppointmentsModel })
  },

  computeds: { },

  validation: { },

  bindWaitListModel: function(data) {
    this.set('isInitialized', true);

    if (!data.success || data.waitingLists.length == 0) {
      this.set('hasAppointments', false);
      this.get('waitLists').reset();
      return;
    }

    this.get('waitLists').reset();

    /*_.each(data.waitingLists, _.bind(function(waitingList) {
      var waitListModel = new WaitListAppointmentsModel();
      waitListModel.bindWaitListEntry(waitingList);

      this.get('waitLists').push(waitListModel);
    }, this));*/

    var waitListModel = new WaitListAppointmentsModel();
    waitListModel.bindWaitListEntry(data.waitingLists[0], data.waitBoardInfo);

    this.get('waitLists').push(waitListModel);

    this.set('hasAppointments', this.get('isInitialized') && this.get('waitLists').length > 0);
  }
});

module.exports = WaitListsAppointmentsModel;